import { Tag } from 'antd';
import { EmailNotificationOverallStatuses, EmailNotificationProviderStatuses } from 'types/common';
import { getEmailNotificationProps } from './utils';

type Props = {
    overallStatus: EmailNotificationOverallStatuses;
    providerStatus?: EmailNotificationProviderStatuses;
};

const EmailNotificationStatusTag = ({
    overallStatus = EmailNotificationOverallStatuses.FAILED,
    providerStatus = EmailNotificationProviderStatuses.BOUNCE,
}: Props) => {
    if (overallStatus === EmailNotificationOverallStatuses.NOT_SENT) {
        return null;
    }

    const { tooltip, tagColor } = getEmailNotificationProps(overallStatus, providerStatus);

    return (
        <Tag style={{ margin: 0 }} color={tagColor}>
            {tooltip}
        </Tag>
    );
};

export default EmailNotificationStatusTag;
